import { useLocation } from 'react-router-dom';
import NewADICreationWizard from '@/pages/NewADICreationWizard';

export default function PuaNuovaRichiesta() {
  const location = useLocation();
  const draft = location.state?.draftData;
  const step = location.state?.draftStep;

  return (
    <NewADICreationWizard
      role="pua"
      backPath="/pua"
      prefillData={false}
      initialData={draft}
      initialStep={step}
    />
  );
}
